const INITIAL_STATE = {
  rotaLista: {
    data: []
  },
  rotas:[],
  rota: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'EMBARQUE_ROTA_FETCH':
        return { ...state, rotaLista: action.payload }
        case 'EMBARQUE_ROTA_PESQUISA':
        return { ...state, rotas: action.payload }
      case 'EMBARQUE_ROTA_SET':
        return { ...state, rota: action.payload }
      default:
        return state
    }
  }